import React from 'react';
import { bindActionCreators } from 'redux';
import { Circles } from "../../common/loadingComponent";
import { connect } from 'react-redux';
import { getParams } from '../../common/utils';
import { isEqual } from 'lodash';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { MomentDate } from '../../common/momentComponent';
import { searchActions, searchStatus, propertySkSearchBy } from '../../../store/searchStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { writeErr } from '../../common/logger';
import CsvExportButton from '../../common/csvExportButton';
import ExcelExportButton from '../../common/excelExportButton';
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import Paging from '../../../components/common/pagingComponent';
import PropertySkCadastreUnit from './propertySkCadastreUnit';
import UnderlinedTitle from "../../common/underlinedTitle";
import BasicRow from '../../reportSections/identData/basicRow';

import './propertySk.scss';

class PropertySkReport extends React.Component {
    mounted = false;
    pageSize = 10;

    state = {
        page: 1,
        exportError: null
    }

    render() {
        if (this.props.search.status === searchStatus.idle)
            return <NoDataComponent />;

        if (this.props.search.status === searchStatus.requested)
            return <Circles />;

        if (this.props.search.status === searchStatus.error) {
            return (<div className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                <Message type="warning" options={{ renderInnerHtml: true }} message={this.props.translate(this.props.search.error.message)} />
            </div>)
        }

        var data = this.getData();
        if (isNullOrUndefined(data) || data.length === 0)
            return <NoDataComponent />;

        var agentLanguage = this.props.user.authentication.profile.agentLanguage;

        return (
            <>
                {this.renderReportDateInformation()}
                <div className='card'>
                    <div className='card-body'>
                        {this.renderContent(data)}
                    </div>
                </div>
                <div className="disclaimer-wrapper">
                    <div className="report-component" style={{ textAlign: "center" }}><Translate id="Report.Footer" /></div>
                    <hr style={{ marginTop: "4px", marginBottom: "4px", height: "1px" }} />
                    <div className="disclaimer-gray">
                        <Translate id="PropertySk.Document.Disclaimer1" /> <Translate id={agentLanguage === 'sk-SK' ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} />
                    </div>
                </div>
            </>
        )
    }

    componentDidMount() {
        this.mounted = true;
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = this.parseParams(getParams(window.location.search));
            if (!isNullOrUndefined(params)) {
                this.props.propertySkSearch(params);
            }
            this.props.resetPdfExport();
        }
    }

    componentDidUpdate() {
        if (!this.mounted)
            return;

        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = this.parseParams(getParams(window.location.search));
            if (!isNullOrUndefined(params) && !isEqual(this.props.search.params, params)) {
                this.props.propertySkSearch(params);
            }
        }
    }

    renderReportDateInformation() {
        return (
            <div className="property-sk-query-date">
                <div>
                    <span className="bold"><Translate id="PropertySk.CadastreUnit.ReportDate" />:&nbsp;</span>
                    <span className="bold"><MomentDate value={new Date()} /></span>
                </div>
            </div>
        );
    }

    renderContent = (data) => {
        const isPerson = this.searchBy() === propertySkSearchBy.personOwnerDeeds;
        return (
            <>
                <div className="ident-data">
                    {this.searchBy() === propertySkSearchBy.companyOwnerDeeds && <>
                        <BasicRow title="PropertySk.CadastreUnit.Company" value={data.name} />
                        <BasicRow title="PropertySk.CadastreUnit.CompanySeat" value={data.address} />
                        <BasicRow title="PropertySk.Search.CompanyId" value={data.companyId} />
                    </>}
                    {this.searchBy() === propertySkSearchBy.personOwnerDeeds && <>
                        <BasicRow title="PropertySk.CadastreUnit.NameAddress" value={data.name} />
                        <BasicRow title="PropertySk.CadastreUnit.BirthDate" value={data.birthDateFormated} />
                        <BasicRow title="PropertySk.CadastreUnit.BirthDateCoowner" value={data.birthDateCoownerFormated} />
                    </>}
                </div>
                <div style={{ display: "flex", marginTop: "1em" }}>
                    <div style={{ display: "flex", flex: "1 1 0px" }}>
                        <ExcelExportButton style={{ margin: "1em 1em 1em 0" }} check={true}
                            onCheckFailed={(exception, exceptionParams) => this.setState({ exportError: { exception: exception, exceptionParams: exceptionParams } })}
                            onCheckSuccessful={() => this.setState({ exportError: null })}
                            disabled={this.props.export.all === false && this.props.export.ids.length === 0}
                            propertySk={{
                                link: isPerson ? "search-od-person" : "search-od-company",
                                params: this.getExcelExportParams(isPerson)
                            }} />
                        <CsvExportButton style={{ margin: "1em 0" }}
                            onCheckFailed={(exception, exceptionParams) => this.setState({ exportError: { exception: exception, exceptionParams: exceptionParams } })}
                            onCheckSuccessful={() => this.setState({ exportError: null })}
                            report="PropertySkReportCsv"
                            disabled={this.props.export.all === false && this.props.export.ids.length === 0}
                            propertySk={{
                                link: isPerson ? "search-od-person" : "search-od-company",
                                entityId: this.props.search.params.entityId,
                                hash: this.props.search.params.hash,
                                all: this.props.export.all,
                                ids: this.props.export.ids
                            }}
                            offlineExport
                        />
                    </div>
                    <UnderlinedTitle header={this.props.translate("PropertySk.CadastreUnit.RecordsFound")} marginBottom />
                    <div style={{ flex: "1 1 0px" }} />
                </div>
                {this.hasExportError() && <div style={{ marginTop: "0.5em", marginBottom: "1em" }}>
                    <Message type="error" message={this.props.translate(this.state.exportError.exception, this.getExceptionParams())} shadowed />
                </div>}
                <table className="table table-report-section table-stretched property-sk-table">
                    <thead>
                        <tr>
                            <th width="25%"><Translate id="PropertySk.Search.Region" /></th>
                            <th width="25%"><Translate id="PropertySk.Search.District" /></th>
                            <th width="25%"><Translate id="PropertySk.Search.Municipality" /></th>
                            <th width="25%"><Translate id="PropertySk.Search.CadastreUnit" /></th>
                            <th></th>
                            <th className="hide-on-mobile"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.cadastreUnits.map((c, index) => <PropertySkCadastreUnit key={c.cadastreUnitId} data={c}
                            hash={this.props.search.params.hash}
                            entityId={this.props.search.params.entityId}
                            expanded={index === 0}
                        />)}
                    </tbody>
                </table>
                {this.renderPaging(data.totalCount)}
            </>
        );
    }

    renderPaging = (totalCount) => {
        return (this.state.page && Math.ceil(totalCount / this.pageSize) > 1) ? (
            <Paging justify="center"
                selectedPage={this.state.page}
                totalPages={Math.ceil(totalCount / this.pageSize)}
                setPage={page => {
                    this.setState({ page: page });
                }} />
        ) : null;
    }

    searchBy = () => isNullOrUndefined(this.props.search.params) ? null : this.props.search.params.searchBy;

    getData = () => {
        switch (this.searchBy()) {
            case propertySkSearchBy.companyOwnerDeeds:
            case propertySkSearchBy.personOwnerDeeds:
                return isNullOrUndefined(this.props.search) ? null : this.props.search.data;
            default:
                return null;
        };
    }

    parseParams = (params) => {
        try {
            switch (parseInt(params.searchBy)) {
                case propertySkSearchBy.companyOwnerDeeds:
                    return {
                        searchBy: propertySkSearchBy.companyOwnerDeeds,
                        entityId: isNullOrUndefined(params.entityId) ? null : parseInt(params.entityId),
                        count: isNullOrUndefined(params.count) ? this.pageSize : parseInt(params.count),
                        offset: isNullOrUndefined(params.offset) ? (this.pageSize * (this.state.page - 1)) : parseInt(params.offset)
                    };
                case propertySkSearchBy.personOwnerDeeds:
                    return {
                        searchBy: propertySkSearchBy.personOwnerDeeds,
                        hash: params.hash,
                        count: isNullOrUndefined(params.count) ? this.pageSize : parseInt(params.count),
                        offset: isNullOrUndefined(params.offset) ? (this.pageSize * (this.state.page - 1)) : parseInt(params.offset)
                    };
                default:
                    return null;
            };
        } catch {
            writeErr("Failed to parse input parameters");
            return null;
        }
    }

    getExcelExportParams = (isPerson) => {
        let params = {
            all: this.props.export.all,
            ids: this.props.export.ids.join("|")
        };

        if (isPerson)
            params["hash"] = this.props.search.params.hash;
        else
            params["entityId"] = this.props.search.params.entityId;

        return params;
    }

    hasExportError = () => !isNullOrUndefined(this.state.exportError) && !isNullOrUndefined(this.state.exportError.exception);
    getExceptionParams = () => this.hasExportError() && !isNullOrUndefined(this.state.exportError.exceptionParams) ? this.state.exportError.exceptionParams : undefined;
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search.propertySk }, export: { ...state.search.exportSettings }, layout: state.layout, user: state.userContext }),
    dispatch => bindActionCreators(searchActions, dispatch)
)(PropertySkReport)));
